export interface InstalledBaseFileTarget {
    nodeId: string;
    fileId: string;
}

/**
 * Matches Novu redirect targets of the form
 *   /installedBase/{nodeId}/files/{fileId}
 * as sent for IoT report notifications. The backend may deliver the target
 * as a relative path or an absolute URL, optionally with query string, hash
 * or trailing slash. Anything else (including deeper installed base tree
 * paths, which the tree splat consumes) returns null.
 */
export function parseInstalledBaseFileNotificationPath(
    path: string | null | undefined,
): InstalledBaseFileTarget | null {
    if (!path) return null;

    let pathname = path;
    try {
        pathname = new URL(path).pathname;
    } catch {
        pathname = pathname.split('?')[0].split('#')[0];
    }

    const match = pathname.match(/^\/installedBase\/([^/]+)\/files\/([^/]+)\/?$/);
    if (!match) return null;

    try {
        return {
            nodeId: decodeURIComponent(match[1]),
            fileId: decodeURIComponent(match[2]),
        };
    } catch {
        return null;
    }
}
